import React from 'react';
import { Link } from 'react-router';
import Stats from 'landing_pages/components/stats';

const STATS = [
  { "statClass": "projects", "stat": "60,000+", "label": "Happy Clients" },
  { "statClass": "creatives", "stat": "10", "label": "Years in Business" },
  { "statClass": "price", "stat": "220,000+", "label": "Creatives" }
];

const VoteHero = () => (
  <section className="hero">
    <div className="row">
      <div className="small-16 medium-9 large-7 columns">
        <div className="hero-container">
          <h1 className="hero-title">Design Done Better.</h1>
          <p className="hero-text">
            High-quality custom logos, print design, web design and naming. Creative solutions
            for every stage of your business.
          </p>
          <div className="hero-actions">
            <Link className="btn btn-quaternary" to="/how-it-works/" target="_blank">
              Learn more
            </Link>
          </div>
        </div>
      </div>
      <div className="small-16 medium-7 large-9 columns">
        <Stats stats={STATS} />
      </div>
    </div>
  </section>
);

export default VoteHero;



// WEBPACK FOOTER //
// ./focus_groups/components/vote_hero.jsx